import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Alert,
  Box,
  Divider,
  Drawer,
  FormControl,
  ListItemButton,
  ListItemText,
  RadioGroup,
  Snackbar,
  Toolbar,
  Typography,
} from "@mui/material";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";

import { drawerWidth } from "../../Libs/Constants/size";
import { primary } from "../../Styles/theme";

export default function Slidebar() {
  const navigate = useNavigate();
  let { userId, situation } = useParams();
  const [open, setOpen] = React.useState(false);

  //--------------------------------------------------//
  //--------------------------------------------------//
  const handleRadioChange = (val: string) => {
    if (userId !== undefined) {
      navigate(`/${val}/` + userId);
    } else {
      setOpen(true);
    }
  };

  //--------------------------------------------------//
  //--------------------------------------------------//
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
      }}
    >
      <Toolbar variant="dense" />
      <Box sx={{ overflow: "auto", pl: 2, overflowX: "hidden" }}>
        <Typography variant="h6" className="mt-4">
          SUBJECT
        </Typography>
        <ListItemButton
          dense
          disableGutters
          sx={{ pl: 2 }}
          onClick={() => navigate("/")}
        >
          <ListItemText
            primary={
              <Typography variant="h5" color="primary" sx={{ height: 20 }}>
                นักศึกษา
              </Typography>
            }
          />
          <ArrowLeftIcon
            color="primary"
            fontSize="large"
            sx={{ position: "absolute", right: -15 }}
          />
        </ListItemButton>
        <Divider color={primary} />

        <FormControl fullWidth sx={{ mt: 5 }} margin="normal">
          <RadioGroup defaultValue={0} name="radio-buttons-group3">
            <ListItemButton dense onClick={() => handleRadioChange("pretest")}>
              <Typography
                variant="body1"
                color={situation === "pretest" ? "primary" : "secondary"}
              >
                PRE TEST
              </Typography>
            </ListItemButton>
            <Divider color={situation === "pretest" ? primary : "#fff"} />

            <ListItemButton
              dense
              onClick={() => handleRadioChange("situation1")}
            >
              <Typography
                variant="body1"
                color={situation === "situation1" ? "primary" : "secondary"}
              >
                SITUATION #1
              </Typography>
            </ListItemButton>
            <Divider color={situation === "situation1" ? primary : "#fff"} />

            <ListItemButton
              dense
              onClick={() => handleRadioChange("situation2")}
            >
              <Typography
                variant="body1"
                color={situation === "situation2" ? "primary" : "secondary"}
              >
                SITUATION #2
              </Typography>
            </ListItemButton>
            <Divider color={situation === "situation2" ? primary : "#fff"} />

            <ListItemButton
              dense
              onClick={() => handleRadioChange("situation3")}
            >
              <Typography
                variant="body1"
                color={situation === "situation3" ? "primary" : "secondary"}
              >
                SITUATION #3
              </Typography>
            </ListItemButton>
            <Divider color={situation === "situation3" ? primary : "#fff"} />

            <ListItemButton dense onClick={() => handleRadioChange("posttest")}>
              <Typography
                variant="body1"
                color={situation === "posttest" ? "primary" : "secondary"}
              >
                POST TEST
              </Typography>
            </ListItemButton>
            <Divider color={situation === "posttest" ? primary : "#fff"} />
          </RadioGroup>
        </FormControl>

        <Snackbar
          open={open}
          autoHideDuration={5000}
          onClose={() => setOpen(false)}
        >
          <Alert
            onClose={() => setOpen(false)}
            severity="warning"
            sx={{ width: "100%" }}
          >
            กรุณาเลือกนักศึกษา!
          </Alert>
        </Snackbar>
      </Box>
    </Drawer>
  );
}
